import { List } from "immutable";
export const mapMediaToTeasers = (items)=>{
    const teasers = items.map((i)=>{
        if (i.Video) console.warn('Videos are not supported in CarouselBlock yet, skipping video item', i.Video);
        if (i.Image) return imageToTeaser(i.Image);
        return null;
    });
    return List(teasers.filter((i)=>i != null));
};
const imageToTeaser = (image)=>({
        title: image.AltText || "",
        subtitle: "",
        label: "",
        imageUrl: image.Teaser,
        imageUrlFallback: image.Fallback,
        imageUrlLarge: image.Teaser2x,
        linkUrl: ""
    });
